import React, { useEffect, useState } from "react";
import { Button, Card, CardBody, CardHeader, Col, Container, Row } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import Select from "react-select"; // Import react-select
import {
  getMovingHistories,
  getProductTypeWithOutHUIDs,
} from "../../../helpers/urlConfig/apiFunctions";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DeleteComponent from "../../../Components/Common/deleteComponent/DeleteComponent";
import { dateChangerFunc, dateParser } from "../../../helpers/dateParser";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import ProductTypeWithOutHUIDCreate from "./ProductTypeWithOutHUIDCreate";
import ProductTypeWithOutHUIDEdit from "./ProductTypeWithOutHUIDEdit";
import NewHUIDCreate from "./NewHUIDCreate";
import { documentTitle } from "../../../helpers/documentTitle";
import errorResponseHandler from "../../../helpers/errorResponseHandler";
import { useParams, useLocation } from "react-router-dom";

const ProductTypeWithOutHUID = () => {
  const [pt_wo_huid_modal_list, set_pt_wo_huid_modal_list] = useState(false);

  const [modal_delete, setmodal_delete] = useState(false);

  const [edit_modal_list, set_edit_modal_list] = useState(false);
  const [move_modal_list, set_move_modal_list] = useState(false);

  const [deleteId, setDeleteProductTypeId] = useState(null);

  const [currentProductType, setCurrentProductType] = useState(null);
  const [moveProductType, setMoveProductType] = useState(null);

  const [productsType, setProductsType] = useState([]);

  const [movingHistoryData, setMovingHistoryData] = useState([]);

  const [filters, setFilters] = useState({
    product_name: null,
    product_type_name: null,
    huid: null,
    gender: null,
    age: null,

    startDate: null,
    endDate: null,
  });

  const pt_wo_huid_tog_list = () =>
    set_pt_wo_huid_modal_list(!pt_wo_huid_modal_list);

  const tog_delete = () => setmodal_delete(!modal_delete);
  const tog_edit = () => set_edit_modal_list(!edit_modal_list);

  const move_tog_list = () => set_move_modal_list(!move_modal_list);

  documentTitle("Product Types");

  const { model_name } = useParams();
  const location = useLocation();

  const modelData = location.state?.message;

  const fetchData = async () => {
    try {
      console.log("message", modelData);
      // const response = await getProductTypeWithOutHUIDs({
      //   model_name: model_name,
      // });
      const response = await getProductTypeWithOutHUIDs(modelData);
      if (response.statusCode === 200) {
        setProductsType(response.data);
      } else {
        console.error("error product type  with out huid", response);
        // errorResponseHandler(response);
      }
    } catch (error) {
      console.error(error.message);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const onClickRemoveBtn = (data) => {
    setDeleteProductTypeId(data);
    tog_delete();
  };

  const handleEditClick = (product) => {
    setCurrentProductType(product);
    set_edit_modal_list(true);
  };

  const handleMoveClick = (product) => {
    setMoveProductType(product);
    set_move_modal_list(true);
  };

  // Handle dropdown filter change
  const handleFilterChange = (field, selectedOption) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [field]: selectedOption ? selectedOption.value : null,
    }));
  };

  // Get unique values for dropdown options
  const getUniqueValues = (field) => {
    return [
      ...new Set(productsType.map((product) => product[field]).filter(Boolean)),
    ].map((value) => ({
      value,
      label: value,
    }));
  };

  // Handle date filter change
  const handleDateChange = (field, value) => {
    setFilters((prev) => ({
      ...prev,
      [field]: value || null,
    }));
  };

  // Filter the product types based on selected filters
  const filteredProductTypes = productsType.filter((product) => {
    // return Object.entries(filters).every(([field, value]) =>
    //   value
    //     ? product[field]?.toString().toLowerCase() === value.toLowerCase()
    //     : true
    // );
    // Check regular filters
    const passesRegularFilters = Object.entries(filters)
      .filter(([field]) => !["startDate", "endDate"].includes(field))
      .every(([field, value]) => {
        if (!value) return true;
        const productValue = product[field]?.toString().toLowerCase();
        return productValue === value.toLowerCase();
      });

    if (!passesRegularFilters) return false;

    // Check date filters
    const productDateStr = product.created_at
      ? dateParser(product.created_at)
      : "";
    const { startDate, endDate } = filters;

    if (startDate && productDateStr < startDate) return false;
    if (endDate && productDateStr > endDate) return false;

    return true;
  });

  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(filteredProductTypes);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Stock");
    XLSX.writeFile(workbook, "Stocks.xlsx");
  };

  const exportToPDF = () => {
    const doc = new jsPDF();
    doc.text("Stock List", 14, 10);
    doc.autoTable({
      head: [
        [
          "SL.No",
          "Product Name",
          "Product Type Name",
          "HUID",
          "Gram",
          "Gender",
          "Age",
          "Stock",
        ],
      ],
      body: filteredProductTypes.map((customer, index) => [
        index + 1,
        customer.product_name,
        customer.product_type_name,
        customer.huid,
        customer.gram,
        customer.gender,
        customer.age,
        customer.stock,
      ]),
    });
    doc.save("Stocks.pdf");
  };

  const getStock = (stock) => {
    if (parseInt(stock) < 2) {
      return (
        <span style={{ fontSize: "10px" }} className="badge bg-danger">
          {stock}
        </span>
      );
    } else {
      return (
        <span style={{ fontSize: "10px" }} className="badge bg-success">
          {stock}
        </span>
      );
    }
  };

  const fetchHistoryData = async () => {
    try {
      const response = await getMovingHistories();

      const result = response.data.filter(
        (item) =>
          item.product_name === modelData.product_name &&
          item.product_type_name === modelData.product_type_name &&
          item.model_name === modelData.model_name
      );

      setMovingHistoryData(result);
    } catch (error) {
      console.error(error.message);
    }
  };

  useEffect(() => {
    fetchHistoryData();
  }, []);

  let pairCount = 0;

  const getHUIDs = (productTypes) => {
    let pairedHUIDs = [];
    if (productTypes.huid == null || productTypes.huid == " ") {
      const parsedHUIDs = JSON.parse(productTypes.pairs);
      pairCount = parsedHUIDs.length;
      parsedHUIDs.map((item) => {
        pairedHUIDs.push(item.huid);
      });

      return pairedHUIDs.map((huid, index) => (
        <span
          key={index}
          style={{ fontSize: "10px" }}
          className="badge bg-danger me-1"
        >
          {huid}
        </span>
      ));
    } else {
      return <span className="badge bg-success">{productTypes.huid}</span>;
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title="Stock Transactions"
            pageTitle="Stocks"
            exportToExcel={exportToExcel}
            exportToPDF={exportToPDF}
            modelName={model_name}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <div id="customerList">
                    {/* <Row className="g-4 mb-3">
                      <Col className="col-sm-auto">
                        <div>
                          <Button
                            color="success"
                            className="add-btn me-1"
                            onClick={pt_wo_huid_tog_list}
                            id="create-btn"
                          >
                            <i className="ri-add-line align-bottom me-1"></i>{" "}
                          </Button>
                        </div>
                      </Col>
                    </Row> */}
                    <Row className="g-4 mb-3">
                      <Col className="col-sm">
                        <Row>
                          {/* <Col className="col-sm-auto">
                            <div>
                              <Button
                                color="success"
                                className="add-btn me-1"
                                onClick={pt_wo_huid_tog_list}
                                id="create-btn"
                              >
                                <i className="ri-add-line align-bottom me-1"></i>{" "}
                              </Button>
                            </div>
                          </Col> */}
                          {[
                            // Define the fields for filtering
                            "product_name",
                            "product_type_name",
                          ].map((field) => (
                            <Col sm="3" key={field}>
                              <Select
                                options={getUniqueValues(field)} // Options for the dropdown
                                isClearable
                                value={
                                  filters[field]
                                    ? {
                                        value: filters[field],
                                        label: filters[field],
                                      }
                                    : null
                                }
                                onChange={(selectedOption) =>
                                  handleFilterChange(field, selectedOption)
                                }
                                placeholder={`Select ${field.replace(
                                  "_",
                                  " "
                                )}`}
                              />
                            </Col>
                          ))}
                          {/* Date Filters */}

                          <Col sm="2">
                            <input
                              type="date"
                              className="form-control"
                              placeholder="Start Date"
                              value={filters.startDate || ""}
                              onChange={(e) =>
                                handleDateChange("startDate", e.target.value)
                              }
                            />
                          </Col>
                          <Col sm="2">
                            <input
                              type="date"
                              className="form-control"
                              placeholder="End Date"
                              value={filters.endDate || ""}
                              onChange={(e) =>
                                handleDateChange("endDate", e.target.value)
                              }
                            />
                          </Col>
                        </Row>
                      </Col>
                    </Row>

                    <div className="table-responsive table-card mt-3 mb-1">
                      <table className="table align-middle table-nowrap">
                        <thead className="table-light">
                          <tr>
                            <th>SL.No</th>
                            <th>Product</th>
                            <th>Type</th>
                            <th>Model</th>
                            <th>Quantity</th>
                            <th>Weight</th>
                            <th>Created At</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {filteredProductTypes.map((products, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{products.product_name || "-"}</td>
                              <td>{products.product_type_name || "-"}</td>
                              <td>{products.model_name || "-"}</td>
                              <td>{getStock(products.stock) || "-"}</td>
                              <td>
                                {products.gram <= 1 ? (
                                  <span
                                    style={{ fontSize: "10px" }}
                                    className="badge bg-danger"
                                  >
                                    {products.gram}
                                  </span>
                                ) : (
                                  (
                                    <span
                                      style={{ fontSize: "10px" }}
                                      className="badge bg-success"
                                    >
                                      {products.gram}
                                    </span>
                                  ) || "-"
                                )}
                              </td>
                              <td>
                                {products.created_at
                                  ? dateChangerFunc(
                                      dateParser(products.created_at)
                                    )
                                  : ""}
                              </td>
                              <td>
                                <div className="d-flex gap-2">
                                  {/* <div className="edit">
                                    <button
                                      className="btn btn-sm btn-primary"
                                      onClick={() => handleMoveClick(products)}
                                    >
                                      Move
                                    </button>
                                  </div> */}
                                  <div className="edit">
                                    <button
                                      className="btn btn-sm btn-success"
                                      onClick={() => handleEditClick(products)}
                                    >
                                      Edit
                                    </button>
                                  </div>
                                  <div className="remove">
                                    <button
                                      className="btn btn-sm btn-danger"
                                      onClick={() => onClickRemoveBtn(products)}
                                    >
                                      Remove
                                    </button>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      {filteredProductTypes.length === 0 && (
                        <div className="text-center mt-4">
                          <p>No Product Type found.</p>
                        </div>
                      )}
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col lg={12}>
              <Card>
                <CardHeader>Moving History</CardHeader>
                <CardBody>
                  <div id="customerList">
                    {/* <Row className="g-4 mb-3">
                      <Col className="col-sm">
                        <Row>
                          <Col sm="2">
                            <input
                              type="date"
                              className="form-control"
                              placeholder="Start Date"
                              value={filters.startDate || ""}
                              onChange={(e) =>
                                handleDateChange("startDate", e.target.value)
                              }
                            />
                          </Col>
                          <Col sm="2">
                            <input
                              type="date"
                              className="form-control"
                              placeholder="End Date"
                              value={filters.endDate || ""}
                              onChange={(e) =>
                                handleDateChange("endDate", e.target.value)
                              }
                            />
                          </Col>
                        </Row>
                      </Col>
                    </Row> */}

                    <div className="table-responsive table-card mt-3 mb-1">
                      <table className="table align-middle table-nowrap">
                        <thead className="table-light">
                          <tr>
                            <th>Tag ID</th>
                            <th>Product</th>
                            <th>Type</th>
                            <th>Model Name</th>
                            <th>HUID</th>
                            {/* <th>Sets</th> */}
                            <th>Gram</th>
                            <th>Description</th>
                            <th>Created At</th>
                          </tr>
                        </thead>
                        <tbody>
                          {movingHistoryData.map((customer, index) => (
                            <tr key={index}>
                              <td>{customer.unique_stock_id}</td>
                              <td>{customer.product_name || "-"}</td>
                              <td>{customer.product_type_name || "-"}</td>
                              <td>{customer.model_name || "-"}</td>
                              <td>{getHUIDs(customer)}</td>
                              {/* <td>{customer.pairs}</td> */}
                              <td>{customer.gram || "-"}</td>
                              <td>{customer.description || "-"}</td>
                              <td>
                                {dateChangerFunc(
                                  dateParser(customer.created_at)
                                ) || "-"}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      {movingHistoryData.length === 0 && (
                        <div className="text-center mt-4">
                          <p>No moving history found.</p>
                        </div>
                      )}
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      <ProductTypeWithOutHUIDCreate
        pt_wo_huid_modal_list={pt_wo_huid_modal_list}
        set_pt_wo_huid_modal_list={set_pt_wo_huid_modal_list}
        pt_wo_huid_tog_list={pt_wo_huid_tog_list}
        fetchData={fetchData}
      />

      {edit_modal_list && (
        <ProductTypeWithOutHUIDEdit
          modal_list={edit_modal_list}
          setmodal_list={set_edit_modal_list}
          tog_list={tog_edit}
          fetchData={fetchData}
          currentProductType={currentProductType}
        />
      )}

      <DeleteComponent
        modal_delete={modal_delete}
        tog_delete={tog_delete}
        fetchData={fetchData}
        deleteId={deleteId}
        keyName="ProductTypeWithOutHUID"
      />

      <NewHUIDCreate
        move_modal_list={move_modal_list}
        set_move_modal_list={set_move_modal_list}
        move_tog_list={move_tog_list}
        fetchData={fetchData}
        moveProductType={moveProductType}
      />

      <ToastContainer />
    </React.Fragment>
  );
};

export default ProductTypeWithOutHUID;
